import { API } from "../api";
import { url } from "../constants";
import {
  IOfferingDetailsResponse,
  IOfferingPayload,
  IOfferingsResponse,
  Offering,
} from "./types";
import { validateArgs } from "../utils";

export class OfferingService {
  constructor(private api: API) {}

  async getAll(params: any): Promise<IOfferingsResponse> {
    const response = await this.api.get<IOfferingsResponse>(url.offering.base, {
      params,
    });
    return (
      response?.data ?? {
        items: [],
        paging: {
          page: 1,
          perPage: params?.limit ?? 0,
          totalItems: 0,
        },
      }
    );
  }

  async getDetails(id: string): Promise<IOfferingDetailsResponse> {
    validateArgs(id);
    const response = await this.api.get<IOfferingDetailsResponse>(
      url.offering.getDetails.replace(":offeringCode", id),
    );

    return (
      response?.data ?? {
        geo_currency: "",
        offering_code: "",
        sp_code: "",
        items: [],
      }
    );
  }

  async create(offering: IOfferingPayload): Promise<Offering> {
    const response = await this.api.post<Offering>(url.offering.base, offering);

    return response?.data as Offering;
  }

  async edit(
    code: string,
    offering: Partial<IOfferingPayload>,
  ): Promise<Offering> {
    validateArgs(code);
    const response = await this.api.patch<Offering>(
      `${url.offering.base}/${code}`,
      offering,
    );

    return response?.data as Offering;
  }
}
